import { render } from "./ContactsView.vue?vue&type=template&id=855a0482&scoped=true&ts=true"
import script from "./ContactsView.vue?vue&type=script&lang=ts"
export * from "./ContactsView.vue?vue&type=script&lang=ts"

import "./ContactsView.vue?vue&type=style&index=0&id=855a0482&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-855a0482"]])

export default __exports__